/** The docs guide for virtual services and for moving video visits off a virtual location. */
export const VIRTUAL_SERVICES_GUIDE_URL =
  "https://docs.decodahealth.com/guides/virtual-services";

const SEEN_PREFIX = "decoda-virtual-services-guide-seen:";

/** Per clinic and person, so one staff member closing it on a shared computer
 *  doesn't hide it from the next. */
function seenKey(tenant: string, userId: string) {
  return `${SEEN_PREFIX}${tenant}:${userId}`;
}

/** Whether this person has seen the window. One seen while the clinic still
 *  needed Decoda to turn virtual services on (stored as anything but "true")
 *  shows once more, now that they can act on it. */
export function hasSeenVirtualServicesGuide(
  tenant: string,
  userId: string,
): boolean {
  try {
    return localStorage.getItem(seenKey(tenant, userId)) === "true";
  } catch {
    // Private browsing: show it, and it can't be remembered.
    return false;
  }
}

export function markVirtualServicesGuideSeen(tenant: string, userId: string) {
  try {
    localStorage.setItem(seenKey(tenant, userId), "true");
  } catch {
    // Private browsing
  }
}

const NOT_SUGGESTED_PREFIX = "decoda-virtual-services-guide-not-suggested:";
// How long a "not a match" answer is trusted before asking the server again,
// so a clinic that later adds a virtual location still gets the window.
const NOT_SUGGESTED_TTL_MS = 7 * 24 * 60 * 60 * 1000;

/** Whether the server said this clinic isn't a match within the last week,
 *  so the check can be skipped. Per clinic, since the answer is the clinic's. */
export function wasRecentlyNotSuggested(tenant: string): boolean {
  try {
    const checkedAt = Number(
      localStorage.getItem(`${NOT_SUGGESTED_PREFIX}${tenant}`),
    );
    return checkedAt > 0 && Date.now() - checkedAt < NOT_SUGGESTED_TTL_MS;
  } catch {
    return false;
  }
}

export function markNotSuggested(tenant: string) {
  try {
    localStorage.setItem(
      `${NOT_SUGGESTED_PREFIX}${tenant}`,
      String(Date.now()),
    );
  } catch {
    // Private browsing
  }
}
